/**
 * BookingsPage — Премиальный список записей
 */
export function BookingsPage(): React.JSX.Element {
  return (
    <div className="px-5 pt-8">
      <h1 className="text-3xl">📅 Журнал записей</h1>
      
      {/* Календарная лента (MVP) */}
      <div className="flex gap-3 overflow-x-auto pb-6 -mx-5 px-5 no-scrollbar">
        <DateCard day="Сегодня" date="14" month="Мая" active />
        <DateCard day="Пт" date="15" month="Мая" />
        <DateCard day="Сб" date="16" month="Мая" />
        <DateCard day="Вс" date="17" month="Мая" />
        <DateCard day="Пн" date="18" month="Мая" />
      </div>

      <div className="space-y-6">
        <div>
          <h2 className="text-sm font-bold uppercase text-[var(--tg-theme-hint-color)] mb-4 tracking-widest">Утро</h2>
          <BookingLarge name="Елена Смирнова" service="Маникюр + Дизайн" time="10:00" dur="90 мин" status="confirmed" />
        </div>

        <div>
          <h2 className="text-sm font-bold uppercase text-[var(--tg-theme-hint-color)] mb-4 tracking-widest">День</h2>
          <BookingLarge name="Михаил Волков" service="Стрижка бороды" time="13:30" dur="30 мин" status="pending" />
          <BookingLarge name="Ольга Данилова" service="Укладка" time="15:00" dur="45 мин" status="confirmed" />
        </div>
      </div>
    </div>
  );
}

function DateCard({ day, date, month, active }: any) {
  return (
    <div className={`flex flex-col items-center justify-center min-w-[80px] h-28 rounded-2xl border-2 transition-all ${
      active 
        ? 'bg-[var(--tg-theme-button-color)] border-[var(--tg-theme-button-color)] text-[var(--tg-theme-button-text-color)] shadow-lg' 
        : 'bg-[var(--tg-theme-secondary-bg-color)] border-transparent text-[var(--tg-theme-text-color)]'
    }`}>
      <span className="text-[10px] font-bold uppercase opacity-60">{day}</span>
      <span className="text-2xl font-black my-1">{date}</span>
      <span className="text-[10px] font-bold uppercase">{month}</span>
    </div>
  );
}

function BookingLarge({ name, service, time, dur, status }: any) {
  return (
    <div className="card-premium flex items-start gap-4 !p-5">
      <div className="flex flex-col items-center justify-center bg-[var(--tg-theme-button-color)]/10 rounded-xl p-3 min-w-[70px]">
        <span className="text-lg font-black text-[var(--tg-theme-button-color)]">{time}</span>
        <span className="text-[10px] font-bold text-[var(--tg-theme-button-color)] opacity-70">{dur}</span>
      </div>
      <div className="flex-1">
        <div className="font-bold text-xl mb-1">{name}</div>
        <div className="text-sm text-[var(--tg-theme-hint-color)] mb-3">{service}</div>
        <div className="flex gap-2">
          {status === 'pending' ? (
            <>
              <button className="flex-1 bg-green-500 text-white text-[10px] font-bold uppercase py-2 rounded-lg">Подтвердить</button>
              <button className="flex-1 bg-red-500/10 text-red-500 text-[10px] font-bold uppercase py-2 rounded-lg">Отмена</button>
            </>
          ) : (
            <div className="text-[10px] font-bold uppercase text-green-500 bg-green-500/10 px-3 py-1 rounded-full">✓ Подтверждено</div>
          )}
        </div>
      </div>
    </div>
  );
}
